{
  "splits": {
    "title": "Royalty Splits",
    "import": "Import",
    "validId": "Please enter a valid ID",
    "duplicateId": "A Blastmaster with this ID already exists",
    "validPercentages": "Please enter valid percentages",
    "added": "Entry added successfully",
    "errorTryAgain": "An error occurred, please try again",
    "validPercentage": "Please enter a valid percentage",
    "percentageRange": "Please enter percentage between 0 and 100",
    "cellUpdated": "Successfully updated cell",
    "blastmasterId": "Blastmaster Id"
  },
  "import": {
    "title": "Import Royalty Splits",
    "selectExcel": "Please select an Excel file (.xlsx).",
    "readSheetsFailed": "Could not read sheets from file.",
    "readWorkbookFailed": "Failed to read workbook.",
    "importFailed": "Import failed.",
    "unexpectedError": "An unexpected error occurred.",
    "readingWorkbook": "Reading workbook...",
    "dropHint": "Drag & drop an .xlsx file here, or click to browse",
    "selectSheet": "Select sheet",
    "hidden": "(hidden)",
    "startCell": "Starting cell (optional - e.g. CG1)",
    "autoDetect": "Auto-detect",
    "startCellHint": "The cell where the \"No.\" column header begins. Leave blank to auto-detect.",
    "dataFoundAt": "Data found starting at cell <cell>{{cell}}</cell>",
    "updated": "Updated",
    "blastmastersUpdated_one": "blastmaster updated",
    "blastmastersUpdated_other": "blastmasters updated",
    "unchanged": "Unchanged",
    "blastmastersAllocated_one": "blastmaster already fully allocated",
    "blastmastersAllocated_other": "blastmasters already fully allocated",
    "warnings": "Warnings",
    "importAnother": "Import Another",
    "done": "Done"
  },
  "areaBalances": {
    "title": "Royalty Area Balances",
    "royaltyArea": "Royalty Area",
    "balanceOpen": "Open",
    "balanceClose": "Close",
    "mining": "Mining",
    "crush": "Crush",
    "tabHistory": "History",
    "tabMovement": "Movement",
    "tabCrusher": "Crusher",
    "stockpileFrom": "Stockpile From",
    "shiftDay": "Day",
    "shiftNight": "Night",
    "notes": "Notes",
    "addedBy": "Added by"
  }
}
